import Button from './CustomButton'
import Title from './Title'
import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusMinus, faArrowRightArrowLeft, faCheck } from '@fortawesome/free-solid-svg-icons'

const ConfirmConciliationModal = ({
  open,
  message,
  onClose,
  onGenerateAdjustment,
  difference,
  actions = [],
  title = 'Confirmar Conciliación'
}) => {
  const [selectedAdjustment, setSelectedAdjustment] = useState(null)
  const simpleAdjustmentAllowed = difference != null && String(difference).trim() !== '' &&
    Number.isFinite(Number(difference)) && Math.abs(Number(difference)) <= 10
  const invalidSelection = selectedAdjustment === null || (selectedAdjustment === 326 && !simpleAdjustmentAllowed)
  useEffect(() => {
    setSelectedAdjustment(null)
  }, [open])
  const saveAction = actions.find(action => action.id === 'save' || action.title === 'Guardar')
  const canChooseAdjustment = Boolean(onGenerateAdjustment && saveAction)
  if (!open) return null

  return (
    <div
      className='fixed inset-0 z-[1700] flex items-center justify-center bg-black/40 backdrop-blur-sm'
      role='dialog'
      aria-modal='true'
      aria-labelledby='confirm-conciliation-title'
    >
      <div
        className='w-[600px] max-w-[90%] overflow-hidden rounded-2xl bg-surface text-text shadow-2xl'
        onClick={event => event.stopPropagation()}
      >
        <div className='flex items-center justify-between bg-primary px-4 py-3'>
          <span />
          <button
            type='button'
            onClick={onClose}
            className='rounded-full p-1 text-white transition-colors hover:bg-white/20'
            aria-label='Cerrar confirmación'
          >
            ✕
          </button>
        </div>

        <div className='flex min-h-[220px] flex-col items-center justify-center px-8 py-6'>
          <Title id='confirm-conciliation-title' className='mb-4 text-center font-sans text-2xl'>
            {title}
          </Title>
          {/*<div className='mb-4 flex h-10 w-10 items-center justify-center rounded-full border-2 border-text'>
            <span className='text-xl font-bold'>!</span>
          </div>*/}
          <p className='text-center font-sans text-lg leading-relaxed text-muted'>{message}</p>
          {canChooseAdjustment && (
            <div className='mt-6 grid w-full gap-4' role='group' aria-label='Opciones de conciliación'>
              {[
                { value: 326, label: 'Generar Ajuste Sencillo', icon: faPlusMinus, description: '' },
                { value: 245, label: 'Generar Ajuste Tipo Cambio', icon: faArrowRightArrowLeft, description: '' },
                { value: 0, label: 'Continuar Sin Ajuste', icon: faCheck, description: '' }
              ].map(option => (
                <button
                  key={option.value}
                  type='button'
                  disabled={option.value === 326 && !simpleAdjustmentAllowed}
                  title={option.value === 326 ? 'Disponible para diferencias de hasta $10' : undefined}
                  onClick={() => setSelectedAdjustment(option.value)}
                  aria-label={option.label}
                  aria-pressed={selectedAdjustment === option.value}
                  className={`flex items-center gap-3 rounded-xl border p-4 text-left font-sans text-sm font-semibold transition disabled:opacity-40 disabled:cursor-not-allowed focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent2 ${
                    selectedAdjustment === option.value
                      ? 'border-accent2 bg-accent2/10'
                      : 'border-gray-200 enabled:hover:border-accent2/40'
                  }`}
                >
                  <span aria-hidden='true' className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${
                    selectedAdjustment === option.value ? 'bg-accent2/15 text-accent2' : 'bg-bg text-muted'
                  }`}>
                    <FontAwesomeIcon icon={option.icon} className='h-4 w-4' />
                  </span>
                  <span className='min-w-0 flex-1'>
                    <span className='block'>{option.label}</span>
                    <span className='mt-1 block text-xs font-normal leading-relaxed text-muted'>{option.description}</span>
                  </span>
                  <span aria-hidden='true' className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border ${
                    selectedAdjustment === option.value ? 'border-accent2 bg-accent2 text-white' : 'border-gray-300'
                  }`}>
                    {selectedAdjustment === option.value && <FontAwesomeIcon icon={faCheck} className='h-3 w-3' />}
                  </span>
                </button>
              ))}
            </div>
          )}
        </div>

        <div className='flex flex-wrap justify-end gap-3 border-t border-border bg-bg px-6 py-4'>
          {actions.slice(0, 3).map(action => (
            <Button
              key={action.id || action.title}
              title={canChooseAdjustment && action === saveAction ? 'Confirmar' : action.title}
              onClick={canChooseAdjustment && action === saveAction ? () => {
                if (invalidSelection) return
                if (selectedAdjustment === 0) saveAction.onClick()
                else onGenerateAdjustment(selectedAdjustment)
              } : action.onClick}
              disabled={action.disabled || (canChooseAdjustment && action === saveAction && invalidSelection)}
              className={`font-sans font-semibold ${
                action.className ||
                'rounded-full bg-primary px-5 text-sm text-white disabled:cursor-not-allowed disabled:opacity-50'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default ConfirmConciliationModal
